/**
 * Helpers compartidos por las pantallas de detalle/autorización de solicitudes
 * (bajas, requisiciones, vacaciones), que usan los estilos de `_approval-detail.scss`.
 */

export type StatusTone = 'draft' | 'review' | 'approved' | 'rejected';

/**
 * Agrupa cualquier estado en un tono (borrador / en revisión / aprobada / rechazada);
 * el SCSS pinta cada tono con el color de la línea de estado de los correos.
 * Acepta los códigos de requisiciones (`APPROVED`) y de vacaciones (`approved_by_boss`).
 */
export function statusTone(code: string | null | undefined): StatusTone {
    const normalized = (code || '').toUpperCase();
    if (normalized === 'DRAFT') {
        return 'draft';
    }
    if (normalized.startsWith('APPROVED')) {
        return 'approved';
    }
    if (normalized === 'REJECTED' || normalized === 'CANCELLED') {
        return 'rejected';
    }
    return 'review';
}

export function fullName(person: any): string {
    if (!person) {
        return '';
    }
    return [person.firstName, person.middleName, person.lastName]
        .filter(Boolean)
        .join(' ');
}

export function initials(name: string | null | undefined): string {
    return (name || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');
}

export function statusIcon(code: string | null | undefined): string {
    const iconMap: { [key: string]: string } = {
        DRAFT: 'pi pi-file',
        PENDING: 'pi pi-clock',
        REVIEW_SUPERVISOR: 'pi pi-user',
        REVIEW_MANAGER: 'pi pi-users',
        REVIEW_FINANCE: 'pi pi-dollar',
        REVIEW_HR: 'pi pi-id-card',
        REVIEW_GM: 'pi pi-star',
        APPROVED: 'pi pi-check',
        REJECTED: 'pi pi-times',
        CANCELLED: 'pi pi-ban',
    };
    return iconMap[(code || '').toUpperCase()] || 'pi pi-circle';
}

export interface ApprovalChainItem {
    role: string;
    person: any;
}
